(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 76276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(91499);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51351);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(35577);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15797);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54013);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62010);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48847);

















var Register = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), country = ref[0], setCountry = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), region = ref1[0], setRegion = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), companyTypes = ref2[0], setCompanyTypes = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), cate = ref3[0], setCate = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), selectCate = ref4[0], setSelectCate = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), selectSubCate = ref5[0], setSelectSubCate = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), selectThreeCate = ref6[0], setSelectThreeCate = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), city = ref7[0], setCity = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref8[0], setIsOpen = ref8[1];
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var checkbox = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_6__/* .IndexContext */ .Z), setIsHeadFoot = ref9.setIsHeadFoot, setLang = ref9.setLang;
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var vcode_key = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(new Date().getTime());
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("".concat(_utils__WEBPACK_IMPORTED_MODULE_9__/* .PRODDOMAIN */ .sC, "/visitor/ajax/get_verify?key=").concat(vcode_key)), reload = ref10[0], setReload = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), countdown = ref11[0], setCountdown = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), idTypes = ref12[0], setIdTypes = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), selectType = ref13[0], setSelectType = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), memberTypes = ref14[0], setMemberTypes = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), forum = ref15[0], setForum = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), purpose = ref16[0], setPurpose = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), business = ref17[0], setBusiness = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), ways = ref18[0], setWays = ref18[1];
    var timerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var btnClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!checkbox.current) {
            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error({
                content: "请先同意《隐私条款》"
            });
            return;
        }
        console.log(selectCate, selectSubCate, formRef.current.getFormState().values);
        formRef.current.validate().then(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var ref, ref1, _values, purpose, business_area, interested_forum, truename, is_forum, way_understand, gender, params, data, ref2, ref3, ref4;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _values = formRef.current.getFormState().values, purpose = _values.purpose, business_area = _values.business_area, interested_forum = _values.interested_forum, truename = _values.truename, is_forum = _values.is_forum, way_understand = _values.way_understand, gender = _values.gender, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_values, [
                            "purpose",
                            "business_area",
                            "interested_forum",
                            "truename",
                            "is_forum",
                            "way_understand",
                            "gender"
                        ]);
                        return [
                            4,
                            request.post("/visitor/do_reg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, params), {
                                gender: gender,
                                is_forum: is_forum,
                                truename: truename,
                                // interest_area: [...selectCate, ...selectSubCate, ...selectThreeCate].join(','),
                                vcode_key: vcode_key.current,
                                // purpose: purpose.join(','),
                                // business_area: business_area.join(','),
                                // interested_forum: !!interested_forum ? interested_forum.join(',') : '',
                                // way_understand: way_understand.join(','),
                                source_ex_id: !!((ref = router.query) === null || ref === void 0 ? void 0 : ref.source_ex_id) ? (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.source_ex_id : ""
                            }))
                        ];
                    case 1:
                        data = _state.sent().data;
                        if ((data === null || data === void 0 ? void 0 : data.code) == 1) {
                            ;
                            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.success */ .FN.success({
                                content: "提交成功"
                            });
                            document.cookie = "v_token=".concat(data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.jwt, "; Expires=").concat(new Date((data === null || data === void 0 ? void 0 : (ref3 = data.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.payload) === null || ref4 === void 0 ? void 0 : ref4.expire) * 1000).toUTCString(), "; Path=/; Secure; SameSite=Lax");
                            router.push("/register/success?name=".concat(truename, "&gender=").concat(gender));
                        } else {
                            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error({
                                content: data.msg
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        })).catch(function(err) {
            console.log(err);
            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error({
                content: "请填写完整信息",
                duration: 3
            });
        });
    }, [
        selectCate,
        selectSubCate,
        selectThreeCate,
        router.query
    ]);
    var sendCaptcha = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        var _values, mobile, vcode, email, user_type, params, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _values = formRef.current.getFormState().values, mobile = _values.mobile, vcode = _values.vcode, email = _values.email, user_type = _values.user_type;
                    if (user_type == "1" && !mobile) {
                        _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error("请输入手机号");
                        return [
                            2
                        ];
                    }
                    if (user_type == "2" && !email) {
                        _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error("请输入邮箱");
                        return [
                            2
                        ];
                    }
                    if (!vcode) {
                        _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error("请输入图形验证码");
                        return [
                            2
                        ];
                    }
                    params = user_type == "1" ? {
                        mobile: mobile,
                        vcode: vcode,
                        vcode_key: vcode_key.current
                    } : {
                        email: email,
                        vcode: vcode,
                        vcode_key: vcode_key.current
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        request.post(user_type == "1" ? "/visitor/ajax/send_sms_code" : "/visitor/ajax/send_email_code", params)
                    ];
                case 2:
                    data = _state.sent().data;
                    if ((data === null || data === void 0 ? void 0 : data.code) != 1) {
                        vcode_key.current = new Date().getTime();
                        setReload("".concat(_utils__WEBPACK_IMPORTED_MODULE_9__/* .PRODDOMAIN */ .sC, "/visitor/ajax/get_verify?key=").concat(vcode_key.current));
                        _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Toast.error */ .FN.error(data === null || data === void 0 ? void 0 : data.msg);
                        return [
                            2
                        ];
                    }
                    // 开始倒计时
                    setCountdown(60);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("验证码发送失败:", error);
                    setCountdown(0); // 出错时重置状态
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var transOption = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (!arr.length) return [];
        return arr === null || arr === void 0 ? void 0 : arr.map(function(item) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, item), {
                childlist: transOption(item.childlist),
                key: item.id,
                value: item.id,
                label: item.name_cn || item.title_cn || item.name
            });
        });
    }, []);
    var findDifference = function(arr1, arr2) {
        // 使用 Set 来方便地进行数组差异的计算
        var set2 = new Set(arr2);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var num = _step.value;
                if (!set2.has(num)) {
                    return num; // 找到第一个不在arr2中的元素并返回
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0;
    };
    var clearNodes = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
        var findNodeRecursive = function(nodes, targetId) {
            return nodes.reduce(function(found, node) {
                if (found) return found; // 如果已经找到，直接返回
                if (node.id === targetId) return node; // 当前节点匹配
                return findNodeRecursive(node.childlist || [], targetId); // 递归查找子节点
            }, null);
        };
        var getAllDescendantIds = function(node) {
            if (!(node === null || node === void 0 ? void 0 : node.childlist)) return [];
            return node.childlist.flatMap(function(child) {
                return [
                    child.id
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(getAllDescendantIds(child)));
            });
        };
        console.log("clear");
        var targetNode = findNodeRecursive(cate, id);
        console.log(targetNode);
        if (!targetNode) return;
        var idsToClear = new Set([
            id
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(getAllDescendantIds(targetNode))));
        console.log(idsToClear);
        setSelectSubCate(function(prev) {
            return prev.filter(function(id) {
                return !idsToClear.has(id);
            });
        });
        setSelectThreeCate(function(prev) {
            return prev.filter(function(id) {
                return !idsToClear.has(id);
            });
        });
    }, [
        cate
    ]);
    var getCity = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(pid) {
            var ref, data, arr;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request.get("/api/region/list", {
                                params: {
                                    pid: pid
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        arr = transOption((0,lodash__WEBPACK_IMPORTED_MODULE_7__.toArray)(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.list));
                        setCity(arr);
                        return [
                            2
                        ];
                }
            });
        });
        return function(pid) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var getFiled = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(filed) {
        return formRef.current.getValue(filed);
    }, [
        formRef.current
    ]);
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, data, ref6, info, ref7, types, ref8, memberTypes, ref9, forum, ref10, purpose, ref11, business, ref12, ways;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/api/region/data")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        4,
                        request.get("/api/setting/info")
                    ];
                case 2:
                    ref6 = _state.sent(), info = ref6.data;
                    return [
                        4,
                        request.get("/visitor/ajax/idcard_types_list")
                    ];
                case 3:
                    ref7 = _state.sent(), types = ref7.data;
                    return [
                        4,
                        request.get("/visitor/ajax/member_types_list")
                    ];
                case 4:
                    ref8 = _state.sent(), memberTypes = ref8.data;
                    return [
                        4,
                        request.get("/visitor/ajax/forum_list")
                    ];
                case 5:
                    ref9 = _state.sent(), forum = ref9.data;
                    return [
                        4,
                        request.get("/visitor/ajax/purpose_types_list")
                    ];
                case 6:
                    ref10 = _state.sent(), purpose = ref10.data;
                    return [
                        4,
                        request.get("/visitor/ajax/business_list")
                    ];
                case 7:
                    ref11 = _state.sent(), business = ref11.data;
                    return [
                        4,
                        request.get("/visitor/ajax/know_way_list")
                    ];
                case 8:
                    ref12 = _state.sent(), ways = ref12.data;
                    setCate(transOption(info === null || info === void 0 ? void 0 : (ref = info.data) === null || ref === void 0 ? void 0 : ref.category));
                    setCompanyTypes(transOption(Array.from((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, info === null || info === void 0 ? void 0 : (ref1 = info.data) === null || ref1 === void 0 ? void 0 : ref1.company_types), {
                        length: Object.keys(info === null || info === void 0 ? void 0 : (ref2 = info.data) === null || ref2 === void 0 ? void 0 : ref2.company_types).length + 1
                    })).slice(1)));
                    setIdTypes(transOption(types === null || types === void 0 ? void 0 : types.data));
                    setMemberTypes(transOption(memberTypes === null || memberTypes === void 0 ? void 0 : memberTypes.data));
                    setForum(transOption(forum === null || forum === void 0 ? void 0 : forum.data));
                    setCountry(transOption(data === null || data === void 0 ? void 0 : (ref3 = data.data) === null || ref3 === void 0 ? void 0 : ref3.country));
                    setRegion(transOption(data === null || data === void 0 ? void 0 : (ref4 = data.data) === null || ref4 === void 0 ? void 0 : ref4.province));
                    setPurpose(transOption(purpose === null || purpose === void 0 ? void 0 : purpose.data));
                    setBusiness(transOption(business === null || business === void 0 ? void 0 : business.data));
                    setWays(transOption(ways === null || ways === void 0 ? void 0 : ways.data));
                    (ref5 = formRef.current) === null || ref5 === void 0 ? void 0 : ref5.setValue("country_id", 256);
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (countdown > 0) {
            timerRef.current = setInterval(function() {
                setCountdown(function(prev) {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return function() {
            return clearInterval(timerRef.current);
        };
    }, [
        countdown
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsHeadFoot(false);
        getData();
        return function() {
            setIsHeadFoot(true);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().container) || ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().content) || ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().header) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-21563d4e62a33c38",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            style: {
                                                color: "#f79700"
                                            },
                                            className: "jsx-21563d4e62a33c38",
                                            children: "为健康发声"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                            className: "jsx-21563d4e62a33c38" + " " + "minHidden"
                                        }),
                                        "为未来行动"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().info) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "jsx-21563d4e62a33c38",
                                            children: "亚洲有机产业展览会"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "jsx-21563d4e62a33c38",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().time) || ""),
                                                    children: "2025.09.03-05"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().site) || ""),
                                                    children: "上海新国际博览中心"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().btns) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://www.organic-festa.com/",
                                            className: "jsx-21563d4e62a33c38",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                style: {
                                                    backgroundColor: "transparent"
                                                },
                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().backBtn) || ""),
                                                children: "返回首页"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/login",
                                            className: "jsx-21563d4e62a33c38",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().backBtn) || ""),
                                                children: "已是观众，返回登录"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().form) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().title) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                            className: "jsx-21563d4e62a33c38",
                                            children: [
                                                "观众登记",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "jsx-21563d4e62a33c38",
                                                    children: "标记*为必填"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown */ .Lt, {
                                            style: {
                                                width: "148px"
                                            },
                                            render: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.Menu */ .Lt.Menu, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.Item */ .Lt.Item, {
                                                        onClick: function() {
                                                            return setLang("cn");
                                                        },
                                                        children: "中文"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.Item */ .Lt.Item, {
                                                        onClick: function() {
                                                            return setLang("en");
                                                        },
                                                        children: "English"
                                                    })
                                                ]
                                            }),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().langBtn) || ""),
                                                children: "语言："
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/image/register-step.png",
                                    alt: "",
                                    className: "jsx-21563d4e62a33c38" + " " + "minHidden"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                                    getFormApi: function(formApi) {
                                        return formRef.current = formApi;
                                    },
                                    labelPosition: "left",
                                    labelWidth: "145px",
                                    labelAlign: "right",
                                    style: {
                                        marginTop: "40px"
                                    },
                                    children: function(param) {
                                        var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-21563d4e62a33c38",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "jsx-21563d4e62a33c38",
                                                    children: "账号信息"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().types) || ""),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.RadioGroup */ .l0.RadioGroup, {
                                                            options: [
                                                                {
                                                                    label: "中国大陆",
                                                                    value: "1"
                                                                },
                                                                {
                                                                    label: "非中国大陆",
                                                                    value: "2"
                                                                }
                                                            ],
                                                            field: "user_type",
                                                            noLabel: true,
                                                            direction: "horizontal",
                                                            initValue: "1",
                                                            onChange: function(e) {
                                                                console.log(e.target.value);
                                                                e.target.value == 1 ? formRef.current.setValue("country_id", 256) : formRef.current.reset([
                                                                    "country_id"
                                                                ]);
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || ""),
                                                    children: [
                                                        getFiled("user_type") == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                            className: "custom",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "手机"
                                                            }),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().phone) || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                        field: "mobile_code",
                                                                        noLabel: true,
                                                                        trigger: "blur",
                                                                        initValue: "86",
                                                                        disabled: true,
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            }, 
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                        field: "mobile",
                                                                        placeholder: "手机号码",
                                                                        noLabel: true,
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            },
                                                                            {
                                                                                pattern: /^1[3-9]\d{9}$/,
                                                                                message: "请输入正确的手机号码"
                                                                            }
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                            field: "email",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "邮箱"
                                                            }),
                                                            placeholder: "请输入邮箱",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                },
                                                                {
                                                                    validator: function(rule, value) {
                                                                        var emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                                                        return emailRegex.test(value);
                                                                    },
                                                                    message: "请输入有效邮箱"
                                                                }
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                            className: "custom",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "图形验证码"
                                                            }),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().imgCode) || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                        field: "vcode",
                                                                        noLabel: true,
                                                                        placeholder: "请输入图形验证码",
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            }, 
                                                                        ]
                                                                    }),
                                                                    reload && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: reload,
                                                                        onClick: function() {
                                                                            vcode_key.current = new Date().getTime();
                                                                            setReload("".concat(_utils__WEBPACK_IMPORTED_MODULE_9__/* .PRODDOMAIN */ .sC, "/visitor/ajax/get_verify?key=").concat(vcode_key.current));
                                                                        },
                                                                        alt: "",
                                                                        className: "jsx-21563d4e62a33c38"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                            className: "custom",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: getFiled("user_type") == "1" ? "手机验证码" : "邮箱验证码"
                                                            }),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().vCode) || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                        field: "vcode",
                                                                        noLabel: true,
                                                                        placeholder: getFiled("user_type") == "1" ? "请输入手机验证码" : "请输入邮箱验证码",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            }, 
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                                                        onClick: (0,lodash__WEBPACK_IMPORTED_MODULE_7__.debounce)(function() {
                                                                            return sendCaptcha();
                                                                        }, 500),
                                                                        disabled: countdown > 0,
                                                                        children: countdown > 0 ? "".concat(countdown, "秒后可重发") : "获取验证码"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                            field: "password",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "设置登录密码"
                                                            }),
                                                            placeholder: "请输入登录密码",
                                                            type: "password",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                },
                                                                {
                                                                    pattern: /^.{6,16}$/,
                                                                    message: "密码需6-16位"
                                                                }
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || ""),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                        field: "verify_password",
                                                        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                            children: "确认登录密码"
                                                        }),
                                                        placeholder: "请输入密码",
                                                        type: "password",
                                                        trigger: "blur",
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "必填项"
                                                            },
                                                            {
                                                                pattern: /^.{6,16}$/,
                                                                message: "密码需6-16位"
                                                            }
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().formTitle) || ""),
                                                    children: "个人信息"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                            field: "truename",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "姓名"
                                                            }),
                                                            placeholder: "请输入姓名",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                }, 
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.RadioGroup */ .l0.RadioGroup, {
                                                            options: [
                                                                {
                                                                    label: "先生",
                                                                    value: "1"
                                                                },
                                                                {
                                                                    label: "女士",
                                                                    value: "2"
                                                                }
                                                            ],
                                                            style: {
                                                                gap: "20px 40px"
                                                            },
                                                            field: "gender",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "称谓"
                                                            }),
                                                            direction: "horizontal",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                }, 
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Select */ .l0.Select, {
                                                            field: "certificates_type",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "证件类型"
                                                            }),
                                                            placeholder: "请选择类型",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                }, 
                                                            ],
                                                            optionList: idTypes,
                                                            onSelect: function(value, option) {}
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                            field: "certificates",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "证件号码"
                                                            }),
                                                            placeholder: "请输入证件号码",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                }, 
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || ""),
                                                    children: [
                                                        getFiled("user_type") == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                            field: "email",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "邮箱"
                                                            }),
                                                            placeholder: "请输入邮箱",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                },
                                                                {
                                                                    validator: function(rule, value) {
                                                                        var emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                                                        return emailRegex.test(value);
                                                                    },
                                                                    message: "请输入有效邮箱"
                                                                }
                                                            ]
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                            className: "custom",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "手机"
                                                            }),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().phone) || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                        field: "mobile_code",
                                                                        noLabel: true,
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            }, 
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                        field: "mobile",
                                                                        placeholder: "手机号码",
                                                                        noLabel: true,
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            },
                                                                            {
                                                                                pattern: /^1[3-9]\d{9}$/,
                                                                                message: "请输入正确的手机号码"
                                                                            }
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                            field: "company_cn",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "公司名称"
                                                            }),
                                                            placeholder: "请输入公司名称",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                }, 
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || "")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().twoCol) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Select */ .l0.Select, {
                                                            filter: true,
                                                            field: "country_id",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "国家/地区"
                                                            }),
                                                            placeholder: "请选择",
                                                            onSelect: function(value, option) {
                                                                formRef.current.setValue("mobile_code", option.code);
                                                            },
                                                            optionList: country,
                                                            disabled: getFiled("user_type") == "1",
                                                            trigger: "blur",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "必填项"
                                                                }, 
                                                            ]
                                                        }),
                                                        getFiled("country_id") == 256 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                            className: "custom",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().required) || ""),
                                                                children: "省份/城市"
                                                            }),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().address) || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Select */ .l0.Select, {
                                                                        filter: true,
                                                                        field: "province_id",
                                                                        noLabel: true,
                                                                        placeholder: "省份",
                                                                        optionList: region,
                                                                        onSelect: function(value, option) {
                                                                            getCity(value);
                                                                            formRef.current.reset([
                                                                                "city_id"
                                                                            ]);
                                                                        },
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            }, 
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Select */ .l0.Select, {
                                                                        filter: true,
                                                                        field: "city_id",
                                                                        noLabel: true,
                                                                        placeholder: "市区",
                                                                        optionList: city,
                                                                        onSelect: function(value, option) {
                                                                            formRef.current.setValue("phone_zone", option.area_code);
                                                                        },
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "必填项"
                                                                            }, 
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().footer) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().allow) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Checkbox */ .XZ, {
                                                    className: "is-check",
                                                    onChange: function(e) {
                                                        return checkbox.current = e.target.checked;
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        style: {
                                                            color: "white"
                                                        },
                                                        className: "jsx-21563d4e62a33c38",
                                                        children: "我已同意"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    onClick: function() {
                                                        return setIsOpen(!isOpen);
                                                    },
                                                    className: "jsx-21563d4e62a33c38",
                                                    children: "《隐私条款》"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-21563d4e62a33c38",
                                                    children: "并确认已阅读及明白上述内容。"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Collapsible */ .zF, {
                                            isOpen: isOpen,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().allowText) || ""),
                                                children: '本人在此授权杜塞尔多夫展览（上海）有限公司 （"MDS"）收集、处理和使用本人提供的信息，用 于内部客户管理。本人知晓：我所提供的信息将会 被传输至MDS的海外集团公司（如：德国杜塞尔多夫 展览集团）以及外部服务提供商做进一步处理/使用。 此外，本人同意MDS及其集团公司基于我向MDS提供的 信息，通过邮递信件、电子邮件、短信/彩信以及电 话等方式向我发送商业讯息（包括但不限于通知、问 卷调查和展览提醒）。'
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().btns) || ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: (0,lodash__WEBPACK_IMPORTED_MODULE_7__.debounce)(function() {
                                                    return btnClick();
                                                }, 500),
                                                className: "jsx-21563d4e62a33c38" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().subBtn) || ""),
                                                children: "提交"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                    id: "21563d4e62a33c38",
                    children: ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "jsx-21563d4e62a33c38",
                    children: [
                        "Copyright \xa9 2025 杜塞尔多夫展览有限（上海）公司  版权所有 ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://beian.miit.gov.cn/",
                            target: "_blank",
                            className: "jsx-21563d4e62a33c38",
                            children: "沪ICP备13014242号-28"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Register);


/***/ }),

/***/ 48847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sC": function() { return /* binding */ PRODDOMAIN; }
/* harmony export */ });
/* unused harmony exports DEVDOMAIN, PRODFORNTDOMAIN */
var DEVDOMAIN = "http://localhost:3001";
// export const PRODDOMAIN = "http://system.icef.com.cn";
var PRODDOMAIN = "https://panel.organic-festa.com";
var PRODFORNTDOMAIN = "https://exhibitor.organic-festa.com";


/***/ }),

/***/ 35577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"register_container__X3g98","content":"register_content__eVuGS","header":"register_header__9xbp8","info":"register_info__U3PwQ","time":"register_time__I_YmD","site":"register_site__Ocev9","btns":"register_btns__yfJ_t","backBtn":"register_backBtn__n50Jg","title":"register_title__XPhol","langBtn":"register_langBtn__t0pD_","form":"register_form__0RoZE","textAreaLabel":"register_textAreaLabel__dj69U","phone":"register_phone__rpfw4","types":"register_types__cJen6","imgCode":"register_imgCode__jEl7x","vCode":"register_vCode__ooWLp","required":"register_required__2bj5_","formTitle":"register_formTitle__bQ_rA","twoCol":"register_twoCol__kRhM_","name":"register_name__qRKIc","marTop":"register_marTop__SD52A","address":"register_address__W1VJ_","forum":"register_forum__AD2dM","item":"register_item__3p68V","list":"register_list__rP6SJ","footer":"register_footer__7eWom","allowText":"register_allowText__FlvkQ","subBtn":"register_subBtn__s448_","download":"register_download__tX84l","allow":"register_allow__kf47S"};

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,774,888,179], function() { return __webpack_exec__(76276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);